const TrialDays = 30;

export default TrialDays;
